import { IProps } from './Interface'
import { makeStyles } from '@material-ui/core/styles'
import { theme } from 'config/constants/theme/theme'

const randomInt = (min: number, max: number) => Math.random() * (max - min) + min

export default makeStyles<{}, IProps>({
  bean: ({ fill, rgbColor, opacity }) => {
    return {
      borderRadius: 100,
      color: 'white',
      background: fill ? `rgba(${rgbColor || '255,255,255'}, ${opacity})` : 'none',
      border: fill ? 'none' : `2px solid rgba(255,255,255, ${opacity})`,
      display: 'inline-block'
    }
  },
  static: ({ size, angle, position }) => {
    return {
      position: 'absolute',
      transform: `rotate(${angle}deg)`,
      width: size?.width,
      height: size?.height,
      top: position?.top,
      bottom: position?.bottom,
      left: position?.left,
      right: position?.right
    }
  },
  animated: {
    position: 'absolute',
    borderRadius: 30,
    padding: '3px 12px',
    marginTop: 5,
    background: '#372A7B',
    textAlign: 'center',
    zIndex: 0,
    height: 27,
    marginLeft: '40vw',
    animationName: '$mui-bean-animation',
    animationFillMode: 'backwards',
    animationIterationCount: 'infinite',
    animationTimingFunction: 'linear',
    animationDuration: `52000ms`,
    animationDelay: ({ index }) => `${randomInt(0, 4000) + Math.floor((index || 0) / 3) * 13000}ms`,
    bottom: ({ index }) => `${((index || 0) % 3) * 30}px`,
    [theme.breakpoints.down('lg')]: {
      marginLeft: '60vw'
    },
    [theme.breakpoints.down('md')]: {
      animationDelay: ({ index }) => `${randomInt(0, 2000) + Math.floor((index || 0) / 3) * 13000}ms`,
      marginLeft: '70vw',
      animationName: '$mui-bean-animation-md'
    },
    [theme.breakpoints.down('sm')]: {
      animationDelay: ({ index }) => `${randomInt(0, 400) + Math.floor((index || 0) / 3) * 12000}ms`,
      marginLeft: '85vw',
      animationName: '$mui-bean-animation-sm'
    }
  },
  beanText: {
    fontSize: 14,
    width: 'max-content'
  },
  '@keyframes mui-bean-animation': {
    '0%': {
      opacity: 0
    },
    '5%': {
      opacity: 1
    },
    '95%': {
      opacity: 1
    },
    '100%': {
      opacity: 0,
      transform: 'translateX(-120vw)'
    }
  },
  '@keyframes mui-bean-animation-md': {
    '0%': {
      opacity: 0
    },
    '5%': {
      opacity: 1
    },
    '95%': {
      opacity: 1
    },
    '100%': {
      opacity: 0,
      transform: 'translateX(-200vw)'
    }
  },
  '@keyframes mui-bean-animation-sm': {
    '0%': {
      opacity: 0
    },
    '5%': {
      opacity: 1
    },
    '95%': {
      opacity: 1
    },
    '100%': {
      opacity: 0,
      transform: 'translateX(-400vw)'
    }
  }
})
